import React from "react";
import { Link } from "react-router-dom";
import { LineChart, Mail } from "lucide-react";

export const Footer = ({ className = "" }) => {
  return (
    <footer
      data-testid="site-footer"
      className={`border-t border-border/60 bg-background/60 ${className}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-2" data-testid="footer-brand">
          <div className="h-6 w-6 rounded-md bg-primary flex items-center justify-center">
            <LineChart className="h-4 w-4 text-primary-foreground" />
          </div>
          <span className="text-sm text-muted-foreground">
            &copy; 2026 <span className="font-semibold text-foreground">Aqvoro AI</span> &middot; Built by{" "}
            <span className="font-semibold text-foreground">Ahmed Faruqui</span>. All rights reserved.
          </span>
        </div>
        <nav className="flex items-center gap-5">
          <a
            href="mailto:ahmedfar683@gmail.com"
            data-testid="footer-contact-link"
            className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            <Mail className="h-3.5 w-3.5" /> Contact
          </a>
          <Link
            to="/about"
            data-testid="footer-about-link"
            className="text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            About
          </Link>
        </nav>
      </div>
    </footer>
  );
};
